export const aboutData = {
  title: 'Who I am',
  description1: "My name's Luis. I'm a Full Stack Developer based in Tecpán Guatemala, Guatemala.",
  description2:
    "During the day I work as a lead developer at a local company and in the evening I work on freelance projects and utilize the time to built my own products. I spend my free hours writing articles and research. Right now I'm also trying a hand at machine learning and AI. I love to learn and explore new arenas.",
  image: 1,
};
